import { useRef } from 'react';
import { NJButton } from '@engie-group/fluid-design-system-react';

export function FileImport({ id, label, accept, disabled, onFile }: {
  id: string; label: string; accept: string; disabled?: boolean; onFile: (file: File) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  return <div>
    <NJButton label={label} variant="secondary" scale="sm" disabled={disabled} onClick={() => input.current?.click()} />
    <input ref={input} id={id} aria-label={label} type="file" accept={accept} hidden disabled={disabled}
      onChange={(event) => {
        const file = event.currentTarget.files?.[0];
        event.currentTarget.value = '';
        if (file) onFile(file);
      }} />
  </div>;
}
